import type { MapPlotOptions } from '../../../PageConfigProvider/types/item';
import type { MetricValues } from '../../../PageConfigProvider/types/metric';
import { LocationType } from '../types';
import { SurfaceAreas } from './surface-areas';

export function normalizePointValue(
  rawValue: number,
  _metric: MetricValues | undefined,
  locationType: LocationType,
  locationId: string,
  mapOptions?: MapPlotOptions,
  locationLabel?: string
): { value: number; displayValue: number } {
  const displayValue = rawValue;

  const normalization = mapOptions?.normalization ?? 'none';
  const transformation = mapOptions?.transformation ?? 'none';

  let value = rawValue;

  if (normalization === 'area_density') {
    const area = getSurfaceAreaForLocation(
      locationType,
      locationId,
      locationLabel
    );

    if (Number.isFinite(area) && area > 0) {
      value = (value / Math.sqrt(area)) * 1_000;
    }
  }

  if (transformation === 'log' && value >= 0) {
    value = Math.log1p(value);
  }

  if (transformation === 'sqrt' && value >= 0) {
    value = Math.sqrt(value);
  }

  return { value, displayValue };
}

function normalizeLabelForArea(raw?: string): string {
  if (!raw) return '';
  let s = (raw || '').trim().toLowerCase();
  s = s.replace(/\s*non[- ]?metro$/i, '').trim();
  s = s.replace(/,\s*united states$/i, '').trim();
  if (s === 'united states' || s === 'united states of america') s = 'usa';
  return s;
}

function getSurfaceAreaForLocation(
  locationType: LocationType,
  locationId: string,
  locationLabel?: string
): number {
  const store = SurfaceAreas[locationType];

  if (!store) {
    return 1;
  }

  if (
    locationType === LocationType.METRO_AREA ||
    locationType === LocationType.STATE
  ) {
    const byId = store[String(locationId)];
    if (Number.isFinite(byId) && (byId as number) > 0) {
      return byId as number;
    }

    return 1;
  }

  const key = normalizeLabelForArea(locationLabel);
  if (!key) return 1;

  const area = store[key];
  if (Number.isFinite(area) && (area as number) > 0) {
    return area as number;
  }

  return 1;
}
